import { Reducer } from 'redux';
import {
    ActionTypes,
    ActionPayload
} from './actions';

interface State {
    loading: boolean
    loginURL: string
    authURL: string
    errorMessage: string
    isLoggedIn: boolean
    loggedInUser: User
}

interface User {
    name: string
    url: string
    photo: string
}

export const initialState: State = {
    loading: false,
    loginURL: "",
    authURL: "",
    errorMessage: "",
    isLoggedIn: false, // TODO should replace this with loggedInUser
    loggedInUser: { name: "", url: "", photo: "" }
}

export const reducer: Reducer<State, ActionPayload> = (state = initialState, action): State => {
    switch (action.type) {

        case ActionTypes.LOGIN_CALLBACK:
        case ActionTypes.LOGIN_INITIATED: {
            return {
                ...state,
                loading: true
            }
        }

        case ActionTypes.LOGIN_URL_UPDATED: {
            return {
                ...state,
                loginURL: action.payload.loginURL
            }
        }

        case ActionTypes.AUTH_URL_RECIEVED: {
            return {
                ...state,
                authURL: action.payload.authURL,
            }
        }

        case ActionTypes.AUTH_URL_ERROR: {
            return {
                ...state,
                loading: false,
                errorMessage: "failed to login",
            }
        }

        case ActionTypes.LOGIN_CALLBACK_SUCCESS: {
            return {
                ...state,
                loading: false,
                loggedInUser: action.payload.user,
            }
        }

        case ActionTypes.SESSION_CHECK_INITIATED: {
            return {
                ...state,
                loading: true
            }
        }

        case ActionTypes.SESSION_CHECK_SUCCESS: {
            return {
                ...state,
                loading: false,
                loggedInUser: action.payload.user,
            }
        }

        case ActionTypes.SESSION_CHECK_ERROR: {
            return {
                ...state,
                loading: false
            }
        }

        default: {
            return state;
        }
    }
}
